var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{staticClass:"site-footer",attrs:{"id":"site-footer","height":"100%"}},[_c('div',{staticClass:"foot-container"},[_c('foot-header'),_c('foot-body'),_c('copy-right')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }